var moment = module.exports = require("./moment-timezone");
moment.tz.load(require('./data/packed/latest.json'));



//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env/~/moment-timezone/index.js
// module id = 540
// module chunks = 0